import { CommonModule } from "@angular/common";
import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormControl, FormGroup, FormsModule, NonNullableFormBuilder, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { CONSTANTS } from "../../../../../Constants/Constants";
import { MatSelectModule } from "@angular/material/select";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { TranslatePipe } from "@ngx-translate/core";
import { CommonDataService } from "../../../../../services/common-data.service";

@Component({
    selector: 'app-sol-properties-sizing-settings',
    templateUrl: './sol-properties-sizing-settings.component.html',
    styleUrls: ['./sol-properties-sizing-settings.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule,
        NgxMaskDirective,
        MatSelectModule,
        MatCheckboxModule,
        TranslatePipe
    ],
    providers: [provideNgxMask()]
})
export class SolPropertiesSizingSettingsComponent implements OnInit {
    sizingSettingsForm!: FormGroup<{
        alnNetworkType: FormControl<string>;
        useHandOffAuto: FormControl<boolean>;
        flnNetworkType: FormControl<string>;
        useOperatorDisplay: FormControl<boolean>;
        spareCapacity: FormControl<string>;
    }>;
    private destroyRef = inject(DestroyRef);

    constructor(private readonly fb: NonNullableFormBuilder,
        private readonly commonDataService: CommonDataService
    ) { }

    ngOnInit(): void {
        this.initializeForm();
        this.setupReadOnlyMode();
    }

    private setupReadOnlyMode(): void {
        this.commonDataService.readOnlyMode$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(isReadOnly => {
                if (isReadOnly) {
                    this.sizingSettingsForm.disable({ emitEvent: false });
                } else {
                    this.sizingSettingsForm.enable({ emitEvent: false });
                }
            });
    }

    private initializeForm(): void {
        this.sizingSettingsForm = this.fb.group({
            alnNetworkType: this.fb.control(CONSTANTS.EMPTY_STRING),
            useHandOffAuto: this.fb.control(false),
            flnNetworkType: this.fb.control(CONSTANTS.EMPTY_STRING),
            useOperatorDisplay: this.fb.control(false),
            spareCapacity: this.fb.control(CONSTANTS.EMPTY_STRING)
        });
    }
}